export const TRANSACTIONAL_MODULE = "transactional"
export const GEOGRAPHIC_SUBMODULE = "transactionalGeographic"
export const COMMERCIAL_SUBMODULE = "transactionalCommercial"
export const BENCHMARK_SUBMODULE = "transactionalBenchmark"
export const BENCHMARK_BY_CHANNEL_SUBMODULE = "transactionalBenchmarkByChannel"
export const BENCHMARK_BY_BRAND_SUBMODULE = "transactionalBenchmarkByBrand"
export const BENCHMARK_BY_FORMAT_SUBMODULE = "transactionalBenchmarkByFormat"
export const BENCHMARK_BY_LOCATION_SUBMODULE =
	"transactionalBenchmarkByLocation"
export const BENCHMARK_TOTAL_SALES_SUBMODULE =
	"transactionalBenchmarkTotalSales"
export const CROSS_SELLING_SUBMODULE = "transactionalCrossSelling"
export const VALUE_SHARED_MODEL_SUBMODULE = "valueSharedModel"
export const VALUE_SHARED_MODEL_BY_LEVEL =
	VALUE_SHARED_MODEL_SUBMODULE + "ByLevel"
export const VALUE_SHARED_MODEL_BY_BRAND =
	VALUE_SHARED_MODEL_SUBMODULE + "ByBrand"
export const VALUE_SHARED_MODEL_BY_CHANNEL =
	VALUE_SHARED_MODEL_SUBMODULE + "ByChannel"
export const VALUE_SHARED_MODEL_BY_FORMAT =
	VALUE_SHARED_MODEL_SUBMODULE + "ByFormat"
export const VALUE_SHARED_MODEL_BY_LOCATION =
	VALUE_SHARED_MODEL_SUBMODULE + "ByLocation"
export const LABS_CROSS_SELLING_SUBMODULE = "labsCrossSelling"
export const LABS_VALUE_SHARE_MODEL_SUBMODULE = "labsValueShareModel"
export const CUSTOMER_BEHAVIOR_MODULE = "customerBehavior"
export const LABS_MODULE = "labs"
export const CUSTOMER_HABITS_SUBMODULE = "customerBehaviorCustomerHabits"
export const CUSTOMER_SWITCHING_GENERAL_METRICS_SUBMODULE =
	"customerBehaviorCustomerSwitching"
export const CUSTOMER_SWITCHING_SWITCHERS_IN_SUBMODULE =
	"customerBehaviorCustomerSwitchingSwitchersIn"
export const CUSTOMER_SWITCHING_SWITCHERS_OUT_SUBMODULE =
	"customerBehaviorCustomerSwitchingOut"
export const CUSTOMER_PROFILING_SUBMODULE = "customerBehaviorCustomerProfiling"
export const PREDICTIVE_CENTER_MODULE = "predictiveCenter"
export const OPERATIONS_MODULE = "operations"
export const OPERATIONS_STORE_SHORTAGES_SUBMODULE = "operationsStoreShortages"
export const ADVERTISEMENT_CENTER_MODULE = "advertisementCenter"
export const MEDIA_CAMPAIGNS_SUBMODULE = "advertisementCenterMediaCampaigns"
export const MEDIA_CAMPAIGNS_EDITOR_SUBMODULE =
	"advertisementCenterMediaCampaignsEditor"
export const PERFORMANCE_MODULE = "performance"
export const PERFORMANCE_EXCLUSIVITY_SUBMODULE = "performanceExclusivity"
export const PERFORMANCE_SUBSTITUTABILITY_SUBMODULE =
	"performanceSubstitutability"
export const PERFORMANCE_GROWTH_PROFILING = "performanceGrowthProfiling"
export const USER_MANAGEMENT_MODULE = "userManagement"
export const USER_MANAGEMENT_SUBMODULE = "userManagementUsers"
export const ORGANIZATIONS_MANAGEMENT_SUBMODULE = "userManagementOrganizations"
export const CONFIGURATION_MODULE = "configuration"
export const CHANGE_PW_SUBMODULE = "changePw"
export const CUSTOMER_BEHAVIOR_LOYALTY_SUBMODULE =
	"customerBehaviorCustomerLoyalty"
export const CUSTOMER_BEHAVIOR_LOYALTY_EVOLUTION_SUBMODULE =
	"customerBehaviorLoyaltyEvolution"
export const CUSTOMER_BEHAVIOR_LOYALTY_FILL_RATE_SUBMODULE =
	"customerBehaviorLoyaltyFillRate"
export const CUSTOMER_BEHAVIOR_CUSTOMER_PROFILING_SUBMODULE =
	"customerBehaviorCustomerProfiling"
export const CUSTOMER_PROFILING_SEGMENTATION_SUMMARY_SUBMODULE =
	"customerBehaviorCustomerProfilingSegmentationSummary"
export const CUSTOMER_PROFILING_DEMOGRAPHIC_SEGMENTATION_SUBMODULE =
	"customerBehaviorCustomerProfilingDemographicSegmentation"
export const CUSTOMER_PROFILING_HABITS_SEGMENTATION_SUBMODULE =
	"customerBehaviorCustomerProfilingHabitsSegmentation"
export const SELLOUT_REPORT_MODULE = "sellout"
export const SELLOUT_REPORT_SUBMODULE = "selloutReport"
export const CAMPAIGN_TRACKER_SUBMODULE = "campaignTracker"

const Modules = [
	TRANSACTIONAL_MODULE,
	GEOGRAPHIC_SUBMODULE,
	COMMERCIAL_SUBMODULE,
	BENCHMARK_SUBMODULE,
	BENCHMARK_BY_BRAND_SUBMODULE,
	BENCHMARK_BY_FORMAT_SUBMODULE,
	BENCHMARK_BY_LOCATION_SUBMODULE,
	BENCHMARK_BY_CHANNEL_SUBMODULE,
	BENCHMARK_TOTAL_SALES_SUBMODULE,
	CROSS_SELLING_SUBMODULE,
	CUSTOMER_BEHAVIOR_MODULE,
	CUSTOMER_HABITS_SUBMODULE,
	CUSTOMER_SWITCHING_GENERAL_METRICS_SUBMODULE,
	CUSTOMER_SWITCHING_SWITCHERS_IN_SUBMODULE,
	CUSTOMER_SWITCHING_SWITCHERS_OUT_SUBMODULE,
	CUSTOMER_PROFILING_SUBMODULE,
	CUSTOMER_BEHAVIOR_LOYALTY_SUBMODULE,
	CUSTOMER_BEHAVIOR_LOYALTY_EVOLUTION_SUBMODULE,
	CUSTOMER_BEHAVIOR_LOYALTY_FILL_RATE_SUBMODULE,
	CUSTOMER_PROFILING_SEGMENTATION_SUMMARY_SUBMODULE,
	CUSTOMER_PROFILING_DEMOGRAPHIC_SEGMENTATION_SUBMODULE,
	CUSTOMER_PROFILING_HABITS_SEGMENTATION_SUBMODULE,
	PREDICTIVE_CENTER_MODULE,
	OPERATIONS_MODULE,
	OPERATIONS_STORE_SHORTAGES_SUBMODULE,
	ADVERTISEMENT_CENTER_MODULE,
	MEDIA_CAMPAIGNS_SUBMODULE,
	MEDIA_CAMPAIGNS_EDITOR_SUBMODULE,
	PERFORMANCE_MODULE,
	PERFORMANCE_EXCLUSIVITY_SUBMODULE,
	PERFORMANCE_SUBSTITUTABILITY_SUBMODULE,
	PERFORMANCE_GROWTH_PROFILING,
	USER_MANAGEMENT_MODULE,
	USER_MANAGEMENT_SUBMODULE,
	SELLOUT_REPORT_MODULE,
	SELLOUT_REPORT_SUBMODULE,
	CAMPAIGN_TRACKER_SUBMODULE,
	LABS_MODULE,
	LABS_CROSS_SELLING_SUBMODULE,
	LABS_VALUE_SHARE_MODEL_SUBMODULE,
	CONFIGURATION_MODULE,
	CHANGE_PW_SUBMODULE,
	VALUE_SHARED_MODEL_SUBMODULE,
	VALUE_SHARED_MODEL_BY_LEVEL,
	VALUE_SHARED_MODEL_BY_BRAND,
	VALUE_SHARED_MODEL_BY_CHANNEL,
	VALUE_SHARED_MODEL_BY_FORMAT,
	VALUE_SHARED_MODEL_BY_LOCATION,
] as const

export type ModulesTypes = typeof Modules[number]

export const ORANGE_COLOR = "#FB8333"
export const BLUE_COLOR = "#004F9A"
export const LIGHT_BLUE_COLOR = "#80B8EE"
